import { FormGroup, FormParagraph, FormSection } from '@ksyos/design-system';
import { useMemo } from 'react';
import { getSelectedLanguage } from '@frontend/translate';
import type { IServiceOrganizationSettingFormSectionProps } from '../ServiceOrganizationSetting';
import { ServiceCode } from '../../../../../../common/enums/serviceCode';
import { RadioGroupField } from '../../../../fields/RadioGroup';
import { ServiceOrganizationSettingFormMode } from '../ServiceOrganizationSetting';

export function SomnologyCanReferPatientWithoutSmartphoneFormSection(
    props: IServiceOrganizationSettingFormSectionProps
) {
    const language = useMemo(
        () => ({
            no: getSelectedLanguage().common.no,
            title: getSelectedLanguage().serviceOrganizationSetting.somnologyCanReferPatientWithoutSmartphone,
            yes: getSelectedLanguage().common.yes,
        }),
        []
    );

    if (props.service.code !== ServiceCode.OSASV) {
        return null;
    }

    return (
        <FormSection title={language.title}>
            <FormGroup label={language.title}>
                {props.mode === ServiceOrganizationSettingFormMode.read ? (
                    <FormParagraph>{props.canReferPatientWithoutSmartphone ? language.yes : language.no}</FormParagraph>
                ) : (
                    <RadioGroupField
                        error={props.errors.get('canReferPatientWithoutSmartphone')}
                        fieldKey="canReferPatientWithoutSmartphone"
                        label=""
                        labels={[language.yes, language.no]}
                        onChange={(value) =>
                            props.handleChange('canReferPatientWithoutSmartphone', value === language.yes)
                        }
                        options={[language.yes, language.no]}
                        value={props.canReferPatientWithoutSmartphone ? language.yes : language.no}
                    />
                )}
            </FormGroup>
        </FormSection>
    );
}
